import {
  InnerBlocks,
  useInnerBlocksProps,
  useBlockProps,
  InspectorControls,
  BlockControls,
} from '@wordpress/block-editor';

import AreaCanvas from '@components/AreaCanvas/AreaCanvas';
import { useSelect } from '@wordpress/data';

import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';

import MediaPicker from '@components/ui/MediaPicker';
import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

import { useEffect } from '@wordpress/element';

export default function Edit({ attributes, setAttributes, clientId }) {
  const {
    media,
    mediaStyle,
    mediaClass,
    pageId,
    flexStyle,
    flexClass,
    biteStyle,
    bitePreset,
  } = attributes;

  const mediaStyleSettings = [];

  const handleMedia = (media) => {
    setAttributes({
      media: media,
    });
  };

  let biteBlockClass = ['bf_layout', flexClass];
  biteBlockClass = biteBlockClass.join(' ');
  const { children, ...innerBlocksProps } = useInnerBlocksProps({
    className: `${biteBlockClass}`,
  });

  const blockProps = useBlockProps({
    className: 'bf_relative',
  });

  return (
    <section {...blockProps}>
      <div {...innerBlocksProps}>{children}</div>
      {media.id ? (
        <>
          {media.type === 'video' ? (
            <ResponsiveVideo
              media={media}
              mediaClass={`${mediaClass}`}
              extraClass={`bf_responsive-media`}
            />
          ) : (
            <ResponsiveImage
              media={media}
              mediaClass={`${mediaClass}`}
              extraClass={`bf_responsive-media`}
            />
          )}
        </>
      ) : null}
      <AreaCanvas
        screen={screen}
        flexStyle={flexStyle}
        biteStyle={biteStyle}
        className={biteBlockClass}
        clientId={clientId}
        setAttributes={setAttributes}
      />
    </section>
  );
}
